export default function (theme, themeOpts, classContent) {
  const widgetName = theme;
  const widgetOpts = themeOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    hasImages: true,
    textOverImage: true,
    imageIsBackground: true,
    lazyLoadImages: false,
    showDescription: false,
    moreButton: false,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const bgImage = data.items[0].ImageWithPath;
      console.log(bgImage);
      
      $(`.${classContent} .tier-1-container`).css(
        "background-image",
        "url(" + `"${bgImage}"` + ")"
      );

      $(`.${classContent}`)
        .find(".tier-1-container")
        .append("<div class='overlay'></div>");
      $(`#${widgetName}`).remove();
    },
  });
}
